/**
 * Manages "removed" Entities, stuck in limbo between being
 * 'deleted' (from user perspective) and formally returned to
 * pools.
 */
var RemovedList = /** @class */ (function () {
    function RemovedList() {
        var _this = this;
        this._list = new Array();
        this._lookup = new Array();
        this.add = function (entity) {
            _this._lookup[entity.id] = _this._list.length;
            _this._list.push(entity);
        };
        this.flush = function (callback) {
            while (_this._list.length) {
                callback(_this._list.shift());
            }
            _this._lookup.length = 0;
        };
        this.get = function (entityId) {
            var _a;
            return (_a = _this._list[_this._lookup[entityId]]) !== null && _a !== void 0 ? _a : null;
        };
    }
    return RemovedList;
}());
export { RemovedList };
//# sourceMappingURL=RemovedList.js.map